var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-drop-down", {
                      attrs: {
                        id: "serviceSpecialist",
                        disabled: _vm.disabled,
                        error: errors[0],
                        fieldkey: "id",
                        fieldname: "name",
                        label: "Especialista de Servicio: ",
                        name: "serviceSpecilist",
                        options: _vm.serviceSpecialists,
                        placeholder: "Seleccione..."
                      },
                      on: {
                        input: function($event) {
                          return _vm.$emit("getSpecialistDetail")
                        }
                      },
                      model: {
                        value: _vm.value.serviceSpecialist,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "serviceSpecialist", $$v)
                        },
                        expression: "value.serviceSpecialist"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("hr")
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("custom-drop-down", {
                      attrs: {
                        id: "writerSpecialist",
                        "custom-error-msg":
                          "Favor de seleccionar la persona que redactó el resumen de resultado.",
                        disabled: _vm.disabled,
                        error: errors[0],
                        fieldkey: "id",
                        fieldname: "name",
                        label: "Persona que redactó el resumen de resultados: ",
                        name: "writerSpecialist",
                        options: _vm.writerSpecialists,
                        placeholder: "Seleccione..."
                      },
                      model: {
                        value: _vm.value.writerSpecialist,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "writerSpecialist", $$v)
                        },
                        expression: "value.writerSpecialist"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("hr")
        ],
        1
      )
    ]),
    !_vm.isNewFeaturesImprovementEnabled
      ? _c("div", { staticClass: "row col-md-12" }, [
          _c(
            "div",
            {
              staticClass: "row bg-white w-100",
              staticStyle: { "min-height": "8vh" }
            },
            [
              _c("div", { staticClass: "col-md-4 mt-4" }, [
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v(" Especialista de Servicio: ")
                ]),
                _c(
                  "span",
                  { staticClass: "color-black font-16 font-weight-bold" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.serviceSpecialistSelected.fullName) + " "
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "col-md-4 mt-4" }, [
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v(" Numero de Licencia: ")
                ]),
                _c("span", { staticClass: "color-black font-16" }, [
                  _vm._v(
                    " " + _vm._s(_vm.serviceSpecialistSelected.licenceNo) + " "
                  )
                ])
              ]),
              _c("div", { staticClass: "col-md-4 mt-4" }, [
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v(" Fecha de Expiración: ")
                ]),
                _c("span", { staticClass: "color-black font-16" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.serviceSpecialistSelected.expirationDate) +
                      " "
                  )
                ])
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }